// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListTable_table__OWXf3 {
    width: 100%;
}

.ListTable_header__eE8J9 {
    line-height: 30px;
}

.ListTable_headerWithSubtitle__7sCgh {
    line-height: 20px;
}

.ListTable_headerItem__gDby6 {
    font-weight: 600;
    vertical-align: top;
    color: var(--color-black);
}

.ListTable_headerItem__gDby6 .ListTable_subtitle__8vUZs {
    font-size: 0.8em;
    font-weight: 400;
    color: var(--color-darkui-accent-2);
    position: relative;
    top: -5px;
}

.ListTable_tableRow__urlv5 {
    border-bottom: 1px solid var(--color-107);
    line-height: 30px;
}

.ListTable_tableRow__urlv5:first-child {
    border-bottom: 1px solid var(--color-107);
    border-top: 1px solid var(--color-107);
}

.ListTable_tableRow__urlv5.ListTable_highlight__ERLUc {
    background-color: var(--color-darkui-accent-3)!important;
    color: var(--color-106);
}

/* make sure that all children of a row have color: --color-106 */
.ListTable_tableRow__urlv5.ListTable_highlight__ERLUc * {
    color: var(--color-106)!important;
}

.ListTable_alternating__vmQkl .ListTable_tableRow__urlv5:nth-child(odd) {
    background-color: var(--color-105);
}

.ListTable_hoverableRows__5pGOT .ListTable_tableRow__urlv5:hover {
    background-color: var(--color-darkui-accent-3)!important;
    color: var(--color-106);
}

.ListTable_hoverableRows__5pGOT .ListTable_tableRow__urlv5:hover *,
.ListTable_alternating__vmQkl .ListTable_hoverableRows__5pGOT .ListTable_tableRow__urlv5:nth-child(odd):hover * {
    color: var(--color-106)!important;
}

.ListTable_tableRow__urlv5.ListTable_clickable__YtO6a {
    cursor: pointer;
}

.ListTable_tableRowItem__G2UKe {
    padding: 5px;
}

.ListTable_tableRowItem__G2UKe.ListTable_rightAlign__tlCR3,
.ListTable_headerItem__gDby6.ListTable_rightAlign__tlCR3 {
    text-align: right;
}

.ListTable_tableRowItem__G2UKe.ListTable_leftAlign__BF7ln,
.ListTable_headerItem__gDby6.ListTable_leftAlign__BF7ln {
    text-align: left;
}

.ListTable_tableRowItem__G2UKe.ListTable_centerAlign__X6JG7,
.ListTable_headerItem__gDby6.ListTable_centerAlign__X6JG7 {
    text-align: center;
}

.ListTable_headerItem__gDby6 input, .ListTable_tableRowItem__G2UKe input {
    vertical-align: middle;
}

@media only screen and (max-width: 61.9375em) {
    .ListTable_hideOnSmallScreens__7PpsO {
        display: none;
    }

    .ListTable_tableRow__urlv5 {
        border-bottom: 1px solid var(--color-107);
        line-height: 20px;
    }
}

.ListTable_fixedHeader__oarZ4{
    position: relative;
    border-collapse: collapse;
}

.ListTable_fixedHeader__oarZ4 th {
    position: sticky;
    top: 0; /* required for the stickiness */
    background: white;
}

.ListTable_noWrap__BxQXL {
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/ListTable/ListTable.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,wDAAwD;IACxD,uBAAuB;AAC3B;;AAEA,iEAAiE;AACjE;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wDAAwD;IACxD,uBAAuB;AAC3B;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,yCAAyC;QACzC,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM,EAAE,gCAAgC;IACxC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".table {\n    width: 100%;\n}\n\n.header {\n    line-height: 30px;\n}\n\n.headerWithSubtitle {\n    line-height: 20px;\n}\n\n.headerItem {\n    font-weight: 600;\n    vertical-align: top;\n    color: var(--color-black);\n}\n\n.headerItem .subtitle {\n    font-size: 0.8em;\n    font-weight: 400;\n    color: var(--color-darkui-accent-2);\n    position: relative;\n    top: -5px;\n}\n\n.tableRow {\n    border-bottom: 1px solid var(--color-107);\n    line-height: 30px;\n}\n\n.tableRow:first-child {\n    border-bottom: 1px solid var(--color-107);\n    border-top: 1px solid var(--color-107);\n}\n\n.tableRow.highlight {\n    background-color: var(--color-darkui-accent-3)!important;\n    color: var(--color-106);\n}\n\n/* make sure that all children of a row have color: --color-106 */\n.tableRow.highlight * {\n    color: var(--color-106)!important;\n}\n\n.alternating .tableRow:nth-child(odd) {\n    background-color: var(--color-105);\n}\n\n.hoverableRows .tableRow:hover {\n    background-color: var(--color-darkui-accent-3)!important;\n    color: var(--color-106);\n}\n\n.hoverableRows .tableRow:hover *,\n.alternating .hoverableRows .tableRow:nth-child(odd):hover * {\n    color: var(--color-106)!important;\n}\n\n.tableRow.clickable {\n    cursor: pointer;\n}\n\n.tableRowItem {\n    padding: 5px;\n}\n\n.tableRowItem.rightAlign,\n.headerItem.rightAlign {\n    text-align: right;\n}\n\n.tableRowItem.leftAlign,\n.headerItem.leftAlign {\n    text-align: left;\n}\n\n.tableRowItem.centerAlign,\n.headerItem.centerAlign {\n    text-align: center;\n}\n\n.headerItem input, .tableRowItem input {\n    vertical-align: middle;\n}\n\n@media only screen and (max-width: 61.9375em) {\n    .hideOnSmallScreens {\n        display: none;\n    }\n\n    .tableRow {\n        border-bottom: 1px solid var(--color-107);\n        line-height: 20px;\n    }\n}\n\n.fixedHeader{\n    position: relative;\n    border-collapse: collapse;\n}\n\n.fixedHeader th {\n    position: sticky;\n    top: 0; /* required for the stickiness */\n    background: white;\n}\n\n.noWrap {\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `ListTable_table__OWXf3`,
	"header": `ListTable_header__eE8J9`,
	"headerWithSubtitle": `ListTable_headerWithSubtitle__7sCgh`,
	"headerItem": `ListTable_headerItem__gDby6`,
	"subtitle": `ListTable_subtitle__8vUZs`,
	"tableRow": `ListTable_tableRow__urlv5`,
	"highlight": `ListTable_highlight__ERLUc`,
	"alternating": `ListTable_alternating__vmQkl`,
	"hoverableRows": `ListTable_hoverableRows__5pGOT`,
	"clickable": `ListTable_clickable__YtO6a`,
	"tableRowItem": `ListTable_tableRowItem__G2UKe`,
	"rightAlign": `ListTable_rightAlign__tlCR3`,
	"leftAlign": `ListTable_leftAlign__BF7ln`,
	"centerAlign": `ListTable_centerAlign__X6JG7`,
	"hideOnSmallScreens": `ListTable_hideOnSmallScreens__7PpsO`,
	"fixedHeader": `ListTable_fixedHeader__oarZ4`,
	"noWrap": `ListTable_noWrap__BxQXL`
};
export default ___CSS_LOADER_EXPORT___;
